<template>

<div class="ew-page">
  <navbar-dashboard name="Integraciones"></navbar-dashboard>

  <div class="ew-page__body">
    <div class="ew-grid">
      <div class="ew-card ew-integration">
        <img src="@/assets/images/woocomerce.png" alt="WooCommerce" class="ew-integration__logo">
        <p class="ew-integration__status" :class="{ 'is-connected': status_wc }">
          <span v-if="status_wc">Conectado</span>
          <span v-else>Desconectado</span>
        </p>
        <label class="ew-switch">
          <input type="checkbox" name="" v-model="status_wc" @change="changeValue">
          <span class="ew-switch__track"></span>
        </label>
      </div>
    </div>

    <b-modal ref="woocommerce" cancel-disabled hide-header hide-footer centered modal-class="ew-modal ew-modal--ecommerce">
      <div class="ew-connect">
        <div class="ew-connect__header">
          <p class="ew-connect__title">Conectar con WooCommerce</p>
          <img src="@/assets/images/logo-woocommerce.png" alt="" class="ew-connect__logo">
        </div>
        <p class="ew-connect__intro">Ingresa la siguiente información para que podamos procesar la nueva integración:</p>
        <form @submit.prevent="conectWoocommerce" class="ew-form">
          <div class="ew-form__field">
            <label class="ew-label" for="wc-url">URL de la tienda *</label>
            <input id="wc-url" type="text" class="ew-input ew-input--block" placeholder="https://mitienda.com" v-model="woocommerce.store_url" required>
          </div>
          <div class="ew-form__field">
            <label class="ew-label" for="wc-name">Nombre de la tienda *</label>
            <input id="wc-name" type="text" class="ew-input ew-input--block" placeholder="Nombre de mi tienda" v-model="woocommerce.app_name" required>
          </div>
          <div class="ew-modal__actions">
            <button type="button" class="ew-btn-outline" @click="hideModalWooCommerce">Cancelar</button>
            <button class="ew-btn-primary" type="submit">Conectar</button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import Navbar from './Header/Navbar'
import commons from '../commons'

import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'Integrations',
  data () {
    return {
      woocommerce:{
          app_name:'',
          store_url:''
      },
      status_app:{
        app_name:'',
        status:true
      },
      status_wc : false,
      origin:false
    }

  },
  created () {
      this.setItemActive('integrations')
      this.getUser();
      this.getStatusWooCommerce()
  },
  watch:{
    status_wc:function(newValue, oldValue) {
      if (this.origin && this.status_wc) {
        this.showModalWooCommerce()
      } else {

      }
    }
  },
  methods: {
    changeValue(){
      if (this.status_wc) {
        this.origin = true
      } else {
        this.setStatusWooCommerce()
        this.origin = false

      }
    },
    showModalWooCommerce () {
      this.$refs.woocommerce.show()
    },
    hideModalWooCommerce() {
      this.origin = false
      this.status_wc = false;
      this.$refs.woocommerce.hide()
    },
    conectWoocommerce(){
      axios.post(`${commons.apiURL}/api/v1/woocommerce/oauth`,{ store_url:this.woocommerce.store_url, app_name:this.woocommerce.app_name, user_id:this.user._id}).then((respose)=>{
          window.location.assign(respose.data.url_auth)
      }).catch(()=>{

      })
    },
    getStatusWooCommerce(){
      let user_id = this.getUserId()
      axios.post(`${commons.apiURL}/api/v1/status/woocommerce`,{ ecommerce_type: 'woocommerce', user_id:user_id}).then((respose)=>{
          if (respose.data) {
            this.status_wc = respose.data.status
            this.origin = false
            this.status_app.app_name = respose.data.app_name
          }
      }).catch((err)=>{
        this.status_wc= false
      })
    },
    setStatusWooCommerce(){
      axios.put(`${commons.apiURL}/api/v1/status/woocommerce/${this.user._id}`,{ ecommerce_type: 'woocommerce', status:false}).then((respose)=>{
          if (respose.data.status) {
            this.status_wc = false
          }
      }).catch((err)=>{
        this.status_wc= false
      })
    },
    getUserId(){
      if (this.$route.query.user_id) {
        return this.$route.query.user_id
      } else if(this.user._id){
        return this.user._id
      }else{
        return localStorage.getItem('ew-user-id')
      }
    },
    ...mapActions(['getUser']),
    ...mapMutations(['setItemActive'])
  },
  computed: {
    ...mapGetters(['user', 'itemActive']),
  },
  components: {
    'navbar-dashboard': Navbar
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; }

.ew-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 260px));
  gap: 1.25rem;
}

.ew-card { @include ew-card; }
.ew-integration {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9rem;
  padding: 2rem 1.5rem;

  &__logo { width: 8rem; height: auto; }

  &__status {
    margin: 0;
    font-family: var(--app-font);
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: var(--app-muted);
    &.is-connected { color: #1a7f4f; }
  }
}

/* Switch --------------------------------------------------------------- */
.ew-switch {
  display: inline-flex;
  cursor: pointer;
  input { position: absolute; opacity: 0; width: 0; height: 0; }
}
.ew-switch__track {
  position: relative;
  width: 46px;
  height: 26px;
  border-radius: 999px;
  background: var(--app-border);
  transition: background-color .15s ease;
  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 20px;
    height: 20px;
    border-radius: 999px;
    background: #fff;
    box-shadow: 0 1px 2px rgba(7, 50, 88, .25);
    transition: transform .15s ease;
  }
}
.ew-switch input:checked + .ew-switch__track {
  background: #1a7f4f;
  &::before { transform: translateX(20px); }
}
.ew-switch input:focus-visible + .ew-switch__track {
  outline: 3px solid var(--app-accent);
  outline-offset: 2px;
}

/* Modal conectar WooCommerce ------------------------------------------- */
.ew-connect { text-align: left; }
.ew-connect__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}
.ew-connect__title {
  margin: 0;
  font-family: var(--app-font);
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--app-navy);
}
.ew-connect__logo { height: 2.2rem; width: auto; }
.ew-connect__intro {
  margin: 0 0 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--app-border);
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-muted);
}

.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }
.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; /* App.vue trae un .ew-form global con max-width:400px legado de los formularios de auth viejos; sin este reset se hereda igual (misma especificidad, propiedades distintas) */ }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }
.ew-modal__actions { display: flex; justify-content: flex-end; gap: 0.6rem; }
</style>

<style lang="scss">
@import "../assets/styles/app-tokens";
.ew-modal {
  .modal-content { border-radius: 0.85rem; border: none; }
  .modal-header { border-bottom: 1px solid $app-border; }
  .modal-title { font-family: $app-font-family; font-weight: 700; color: $app-navy; }
}
.ew-modal--ecommerce .modal-dialog { max-width: 500px; }
</style>



// WEBPACK FOOTER //
// src/components/Integrations.vue